// role.guard.ts
import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivate,
} from "@angular/router";
import { JwtService } from "../services/core/jwt.service";

@Injectable({
  providedIn: "root",
})
export class RoleGuard implements CanActivate {
  constructor(
    private authService: JwtService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(["/auth/login"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    } else {
      const expectedRoles = route.data["roles"] as string[];
      if (this.authService.hasRole(expectedRoles)) {
        // console.log("has roles");
        return true;
      } else {
        // console.log("no role");
        // Optional: Navigate to unauthorized page or fallback
        this.router.navigate(["/error403"]);
        return false;
      }
    }
  }
}
